// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as privateResourcesRouteRouteImport } from './routes/(private)/resources/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as privateAgentsIndexRouteImport } from './routes/(private)/agents/index'
import { Route as privateAskIndexRouteImport } from './routes/(private)/ask/index'
import { Route as privateBillingIndexRouteImport } from './routes/(private)/billing/index'
import { Route as privateBriefingIndexRouteImport } from './routes/(private)/briefing/index'
import { Route as privateDashboardIndexRouteImport } from './routes/(private)/dashboard/index'
import { Route as privateGovernanceIndexRouteImport } from './routes/(private)/governance/index'
import { Route as privateLibraryIndexRouteImport } from './routes/(private)/library/index'
import { Route as privateModelsIndexRouteImport } from './routes/(private)/models/index'
import { Route as privateNotificationsIndexRouteImport } from './routes/(private)/notifications/index'
import { Route as privateResourcesIndexRouteImport } from './routes/(private)/resources/index'
import { Route as privateReviewIndexRouteImport } from './routes/(private)/review/index'
import { Route as privateSettingsIndexRouteImport } from './routes/(private)/settings/index'
import { Route as publicCallbackIndexRouteImport } from './routes/(public)/callback/index'
import { Route as publicContactIndexRouteImport } from './routes/(public)/contact/index'
import { Route as publicLoginIndexRouteImport } from './routes/(public)/login/index'
import { Route as publicLogoutIndexRouteImport } from './routes/(public)/logout/index'
import { Route as publicNewPasswordIndexRouteImport } from './routes/(public)/new-password/index'
import { Route as publicPrivacyIndexRouteImport } from './routes/(public)/privacy/index'
import { Route as publicSignupIndexRouteImport } from './routes/(public)/signup/index'
import { Route as publicTermsIndexRouteImport } from './routes/(public)/terms/index'
import { Route as publicVerifyEmailIndexRouteImport } from './routes/(public)/verify-email/index'
import { Route as privateLibraryDocumentIdIndexRouteImport } from './routes/(private)/library/$documentId/index'
import { Route as privateResourcesChangelogIndexRouteImport } from './routes/(private)/resources/changelog/index'
import { Route as privateResourcesDocsIndexRouteImport } from './routes/(private)/resources/docs/index'
import { Route as privateResourcesRoadmapIndexRouteImport } from './routes/(private)/resources/roadmap/index'

const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const privateResourcesRouteRoute = privateResourcesRouteRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => privateRouteRoute
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/(public)/',path: '/',getParentRoute: () => rootRouteImport
          })
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => OnboardingRouteRoute
          })
const privateAgentsIndexRoute = privateAgentsIndexRouteImport.update({
            id: '/agents/',path: '/agents/',getParentRoute: () => privateRouteRoute
          })
const privateAskIndexRoute = privateAskIndexRouteImport.update({
            id: '/ask/',path: '/ask/',getParentRoute: () => privateRouteRoute
          })
const privateBillingIndexRoute = privateBillingIndexRouteImport.update({
            id: '/billing/',path: '/billing/',getParentRoute: () => privateRouteRoute
          })
const privateBriefingIndexRoute = privateBriefingIndexRouteImport.update({
            id: '/briefing/',path: '/briefing/',getParentRoute: () => privateRouteRoute
          })
const privateDashboardIndexRoute = privateDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => privateRouteRoute
          })
const privateGovernanceIndexRoute = privateGovernanceIndexRouteImport.update({
            id: '/governance/',path: '/governance/',getParentRoute: () => privateRouteRoute
          })
const privateLibraryIndexRoute = privateLibraryIndexRouteImport.update({
            id: '/library/',path: '/library/',getParentRoute: () => privateRouteRoute
          })
const privateModelsIndexRoute = privateModelsIndexRouteImport.update({
            id: '/models/',path: '/models/',getParentRoute: () => privateRouteRoute
          })
const privateNotificationsIndexRoute = privateNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => privateRouteRoute
          })
const privateResourcesIndexRoute = privateResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => privateResourcesRouteRoute
          })
const privateReviewIndexRoute = privateReviewIndexRouteImport.update({
            id: '/review/',path: '/review/',getParentRoute: () => privateRouteRoute
          })
const privateSettingsIndexRoute = privateSettingsIndexRouteImport.update({
            id: '/settings/',path: '/settings/',getParentRoute: () => privateRouteRoute
          })
const publicCallbackIndexRoute = publicCallbackIndexRouteImport.update({
            id: '/(public)/callback/',path: '/callback/',getParentRoute: () => rootRouteImport
          })
const publicContactIndexRoute = publicContactIndexRouteImport.update({
            id: '/(public)/contact/',path: '/contact/',getParentRoute: () => rootRouteImport
          })
const publicLoginIndexRoute = publicLoginIndexRouteImport.update({
            id: '/(public)/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const publicLogoutIndexRoute = publicLogoutIndexRouteImport.update({
            id: '/(public)/logout/',path: '/logout/',getParentRoute: () => rootRouteImport
          })
const publicNewPasswordIndexRoute = publicNewPasswordIndexRouteImport.update({
            id: '/(public)/new-password/',path: '/new-password/',getParentRoute: () => rootRouteImport
          })
const publicPrivacyIndexRoute = publicPrivacyIndexRouteImport.update({
            id: '/(public)/privacy/',path: '/privacy/',getParentRoute: () => rootRouteImport
          })
const publicSignupIndexRoute = publicSignupIndexRouteImport.update({
            id: '/(public)/signup/',path: '/signup/',getParentRoute: () => rootRouteImport
          })
const publicTermsIndexRoute = publicTermsIndexRouteImport.update({
            id: '/(public)/terms/',path: '/terms/',getParentRoute: () => rootRouteImport
          })
const publicVerifyEmailIndexRoute = publicVerifyEmailIndexRouteImport.update({
            id: '/(public)/verify-email/',path: '/verify-email/',getParentRoute: () => rootRouteImport
          })
const privateLibraryDocumentIdIndexRoute = privateLibraryDocumentIdIndexRouteImport.update({
            id: '/library/$documentId/',path: '/library/$documentId/',getParentRoute: () => privateRouteRoute
          })
const privateResourcesChangelogIndexRoute = privateResourcesChangelogIndexRouteImport.update({
            id: '/changelog/',path: '/changelog/',getParentRoute: () => privateResourcesRouteRoute
          })
const privateResourcesDocsIndexRoute = privateResourcesDocsIndexRouteImport.update({
            id: '/docs/',path: '/docs/',getParentRoute: () => privateResourcesRouteRoute
          })
const privateResourcesRoadmapIndexRoute = privateResourcesRoadmapIndexRouteImport.update({
            id: '/roadmap/',path: '/roadmap/',getParentRoute: () => privateResourcesRouteRoute
          })





const privateResourcesRouteRouteChildren = {
  privateResourcesIndexRoute: privateResourcesIndexRoute,privateResourcesChangelogIndexRoute: privateResourcesChangelogIndexRoute,privateResourcesDocsIndexRoute: privateResourcesDocsIndexRoute,privateResourcesRoadmapIndexRoute: privateResourcesRoadmapIndexRoute
}

const privateResourcesRouteRouteWithChildren = privateResourcesRouteRoute._addFileChildren(privateResourcesRouteRouteChildren)



const privateRouteRouteChildren = {
  privateResourcesRouteRoute: privateResourcesRouteRouteWithChildren,privateAgentsIndexRoute: privateAgentsIndexRoute,privateAskIndexRoute: privateAskIndexRoute,privateBillingIndexRoute: privateBillingIndexRoute,privateBriefingIndexRoute: privateBriefingIndexRoute,privateDashboardIndexRoute: privateDashboardIndexRoute,privateGovernanceIndexRoute: privateGovernanceIndexRoute,privateLibraryIndexRoute: privateLibraryIndexRoute,privateModelsIndexRoute: privateModelsIndexRoute,privateNotificationsIndexRoute: privateNotificationsIndexRoute,privateReviewIndexRoute: privateReviewIndexRoute,privateSettingsIndexRoute: privateSettingsIndexRoute,privateLibraryDocumentIdIndexRoute: privateLibraryDocumentIdIndexRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)




const OnboardingRouteRouteChildren = {
  OnboardingIndexRoute: OnboardingIndexRoute
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(OnboardingRouteRouteChildren)

const rootRouteChildren = {
  privateRouteRoute: privateRouteRouteWithChildren,OnboardingRouteRoute: OnboardingRouteRouteWithChildren,publicIndexRoute: publicIndexRoute,publicCallbackIndexRoute: publicCallbackIndexRoute,publicContactIndexRoute: publicContactIndexRoute,publicLoginIndexRoute: publicLoginIndexRoute,publicLogoutIndexRoute: publicLogoutIndexRoute,publicNewPasswordIndexRoute: publicNewPasswordIndexRoute,publicPrivacyIndexRoute: publicPrivacyIndexRoute,publicSignupIndexRoute: publicSignupIndexRoute,publicTermsIndexRoute: publicTermsIndexRoute,publicVerifyEmailIndexRoute: publicVerifyEmailIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)